import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 中
export default {
    license: {
        powered_by: 'SAIC International {\'|\'} جميع الحقوق محفوظة',
    },
    auth: {
        login: 'تسجيل الدخول',
        username: 'اسم المستخدم',
        username_placeholder: 'يرجى إدخال اسم المستخدم',
        password: 'كلمة السر',
        password_placeholder: 'يرجى إدخال كلمة المرور',
        code: 'رمز التحقق',
        code_placeholder: 'يرجى إدخال رمز التحقق',
        logout: 'الشطب',
        logout_success: 'تم تسجيل الخروج بنجاح',
        day: 'يا إلهي',
        password_expiration: 'انتهت صلاحية كلمة المرور ، يرجى تعديلها',
        expire: 'لم يتبق بعد انتهاء صلاحية كلمة المرور',
        conseils:
            'يجب أن تحتوي على أحرف كبيرة ، أحرف صغيرة ، أرقام ، رموز خاصة ({ msg }) ، طول كلمة المرور 8-16 بت',
        brand_Selection: 'اختيار العلامة التجارية',
        unread_notices: 'إعلان غير مقروء',
        new_cases: 'حالات جديدة ',
        unanswered_cases: 'الحالات التي لم يتم الرد عليها',
        overdue_cases: 'حالات التأخير',
    },
    button: {
        query: 'استفسار',
        editing_position: 'وظائف التحرير',
        show_theme_editor: 'إظهار/إخفاء محرر الموضوع',
        change_password: 'تغيير كلمة المرور',
        old_password: 'كلمة السر القديمة',
        new_password: 'كلمة السر الجديدة',
        confirm_password: 'تأكيد كلمة المرور',
        button: 'زر',
        about: 'حول',
        back: 'العودة',
        go: 'تأكيد',
        home: 'الصفحة الرئيسية',
        confirm: 'تأكيد',
        modify: 'تعديل',
        edit: 'تحرير',
        new: 'إضافة جديدة',
        cancel: 'إلغاء',
        close: 'إغلاق',
        search: 'بحث',
        reset: 'إعادة تعيين',
        delete: 'حذف',
        add: 'إضافة',
        collapse: 'طي',
        expand: 'توسيع',
        download_template: 'تنزيل القالب',
        batch_import: 'استيراد دفعة',
        import: 'استيراد',
        export: 'تصدير',
        export_fail: 'فشل التصدير',
        detailed: 'التفاصيل',
        details: 'التفاصيل',
        download: 'تنزيل',
        toView: 'عرض',
        toViews: 'عرض الصور',
        uploadAttachments: 'رفع المرفقات',
        selectFile: 'اختيار ملف',
        fillingInstructions: 'تعليمات التعبئة',
        release: 'نشر',
        release_recall: 'سحب النشر',
        save: 'حفظ',
        send: 'إرسال',
        tips: 'تلميحات',
        send_back: 'إرجاع',
        examine: 'مراجعة',
        void: 'إبطال',
        more: 'المزيد',
        refresh: 'تحديث',
        selects: 'يرجى الاختيار',
        serial_number: 'الرقم التسلسلي',
        upload_progress: 'تقدم الرفع',
        invalid: 'غير صالح',
        daily_record: 'السجل اليومي',
        operation_type: 'نوع العملية',
        field_name: 'اسم الحقل',
        edit_role: 'تحرير الدور',
        user_role: 'اختيار الدور',
        assignment_role: 'الدور',
        post: 'المنصب',
        sending: 'قيد الإرسال',
        reset_password: 'إعادة تعيين كلمة المرور',
        display_or_not: 'هل يتم العرض؟',
        document: 'مستند',
        specificTemplates: 'قوالب محددة',
        transferOrder: 'أمر التحويل',
        forwarding: 'إعادة التوجيه',
        one_click_notification: 'إشعار بنقرة واحدة',
        english_export: 'تصدير باللغة الإنجليزية',
        oneclick_download: 'تنزيل بنقرة واحدة',
        passwordmsga: 'يجب أن تحتوي على أحرف كبيرة، وأحرف صغيرة، وأرقام، ورموز خاصة (@\\$!_~\\&*)',
        passwordmsgb: 'يجب أن يكون طول كلمة المرور بين 8 و16 حرفًا',
        passwordmsgc: 'يجب ألا تتطابق مع آخر 6 كلمات مرور استُخدمت',
        export_file_list: 'قائمة الملفات المصدرة',
        personal_center: 'المركز الشخصي',
        upload_list: 'قائمة الرفع',
        clear_completed: 'مسح المكتملة',
    },
    radio: {
        enabled: 'تمكين',
        disabled: 'تعطيل',
        catalogue: 'الدليل',
        individual: 'أفراد',
        all: 'الكل',
        yes: 'نعم',
        no: 'لا',
    },
    dropdown: {
        close_others: 'إغلاق الباقي',
        close_right: 'إغلاق إلى اليمين',
        close_left: 'إغلاق إلى اليسار',
    },
    table: {
        action: 'العمليات',
        explain: 'الشروح',
        fileName: 'اسم المرفق',
        size: 'الحجم (ميغابايت)',
        uploader: 'إلى الأمام',
        uploadTime: 'وقت التحميل',
        system: 'النظام',
        caption: 'العنوان',
        categorization: 'التصنيف',
        link: 'الرابط',
        forwarding_time: 'وقت إعادة التوجيه',
        forwarder: 'إعادة توجيه الناس',
        send_to: 'إرسال كائن',
        mode: 'النموذج',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} / صفحة`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `إجمالي ${named('number')} سجل`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `إجمالي ${named('number')} مركبة`,
    },
    confirm: {
        confirm_deletion: 'تأكيد الحذف ؟',
        confirm_void: 'تأكيد بطلان ؟',
        confirm_release: 'تأكيد النشر ؟',
        ack: 'تأكيد.',
        cancel: 'ألغيت',
        non_records: 'يرجى تحديد قطعة واحدة على الأقل من البيانات',
    },
    request: {
        failed_placeholder: 'فشل الطلب ، خطأ في الخادم',
        success_placeholder: 'نجح الطلب',
        auth: {
            login_success: 'تم تسجيل الدخول بنجاح',
        },
        error: {
            '404': 'مسار الطلب غير موجود',
            '403': 'أذونات غير كافية',
        },
    },
    page: {
        global: {
            page_search: 'بحث الصفحة',
        },
        error: {
            not_found: 'لم يتم العثور على الصفحة',
            not_found_des: 'لا يوجد شيء هنا.',
            auth_failed: 'أذونات غير كافية',
            auth_failed_des: 'هذه الصفحة محظورة',
            file_format_error: 'تنسيق الملف غير طبيعي!',
            preview_failed: 'فشلت المعاينة! الملف غير طبيعي!',
        },
        homepage: {
            homepage: homepage.homepage.arSA,
        },
        system: {
            menu: system.menu.arSA,
            dict: system.dict.arSA,
            dept: system.dept.arSA,
            role: system.role.arSA,
            user: system.user.arSA,
        },
        info: {
            announcement: Info.announcement.announcement.arSA,
            document: Info.document.document.arSA,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.arSA,
                recallActivity: tech.quality.recallActivity.arSA,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.arSA,
            },
            management: {
                inquiryOd: tech.management.inquiry.arSA,
                permission: tech.management.permission.arSA,
                onSiteSupportHq: tech.management.onSiteSupport.arSA,
                progHistoryHq: tech.management.progHistory.arSA,
                salesRecordHq: tech.management.salesRecord.arSA,
                vehicleInfoHq: tech.management.vehicleInfo.arSA,
                claimHq: tech.management.claim.arSA,
                filterHq: tech.management.filter.arSA,
                newCarlssue: tech.management.newCarIssue.arSA,
                newCarDefinition: tech.management.newCarDefinition.arSA,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.arSA,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.arSA,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.arSA,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.arSA,
        },
        statistics: statistics.inquiryStatistics.arSA,
        systemClassifyA: statistics.systemClassifyA.arSA,
        systemClassifyB: statistics.systemClassifyB.arSA,
        engineerStatistics: statistics.engineerStatistics.arSA,
        defectivePart: statistics.defectivePart.arSA,
        replyInquiryStatistics: statistics.replyInquiryStatistics.arSA,
        passRateStatistics: statistics.passRateStatistics.arSA,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.arSA,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.arSA,
        customsClearance135Rate: statistics.customsClearance135Rate.arSA,
        accumulatedClosureRate: statistics.accumulatedClosureRate.arSA,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.arSA,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.arSA,
    },
    validation: {
        common: {
            required: 'هذا مطلوب',
            numeric: 'يجب أن يكون عددًا صحيحًا',
            decimal: 'يجب أن يكون رقميا',
            positive_interger: 'يجب أن تكون صحيحة موجبة',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `ما يصل إلى ${named('number')} أرقام`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `لا يمكن أن يتجاوز ${named('number')}كلمة`,

            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `تجاوز الحد الأقصى لعدد الأحرف(${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `لا يقل عن ${named('number')} حرفًا`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `يجب أن يكون ${named('number')} حرفًا بالضبط`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `لا يمكن أن يزيد عن ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `لا يمكن أن يقل عن ${named('number')}`,
            up_to_2_decimal_places: 'بحد أقصى منزلتين عشريتين',
            retain_up: 'أدخل ما يصل إلى 10 أرقام صحيحة موجبة، وبحد أقصى منزلتين عشريتين',
            retain_ups: 'أدخل ما يصل إلى 11 رقمًا صحيحًا موجبًا، وبحد أقصى 4 خانات عشرية',
            input_number: 'يرجى إدخال أرقام عربية',
            only_number_a: 'يمكنك إدخال أحرف أو أرقام فقط',
            translate: 'يجب أن تكون أحرف فقط',
            positive_integer: 'يرجى تعبئة حقل واحد على الأقل',
            at_least_one: 'يرجى تعبئة حقل واحد على الأقل',
        },
        tip: {
            incomplete_information: 'المعلومات غير مكتملة',
        },
    },
    import: {
        template_file: 'ملف القالب',
        browse: 'تصفح',
        download_template: 'تحميل القالب',
        no_file_selected: 'لم يتم تحديد ملف',
        incorrect_file_type: 'نوع الملف غير صحيح',
        exceed: 'تجاوز',
        upload_success: 'تم التحميل بنجاح',
        upload_fail: 'فشل التحميل',
        again_upload:
            'يمكنك فقط تحميل ملفات الصور بتنسيق jpg و png و bmp و gif ، يرجى إعادة التحميل',
        attachmentUpload: 'تحميل المرفقات',
        otherAttachmentUpload: 'مرفقات أخرى مرفوعة',
        supportedFormats: 'دعم التنسيق',
        preview: 'المعاينة',
    },
    export: {
        noDataToExport: 'لا توجد بيانات قابلة للتصدير',
    },
    select: {
        all: 'كل شيء',
    },
    checkbox: {
        select_all: 'إختيار الكل',
    },
    dialog: {
        error_message: 'رسالة خطأ',
        one_year: 'تصدير المستندات لمدة تصل إلى عام واحد',
    },
    ymd: {
        year: 'السنة',
        month: 'الشهر',
        day: 'اليوم',
        week: 'تشو',
        january: 'يناير',
        february: 'شباط/فبراير',
        march: 'آذار/مارس',
        april: 'أبريل',
        may: 'مايو',
        june: 'حزيران/يونيه',
        july: 'تموز/يوليه',
        august: 'آب/أغسطس',
        september: 'أيلول/سبتمبر',
        october: 'تشرين الأول/أكتوبر',
        november: 'تشرين الثاني/نوفمبر',
        december: 'كانون الأول/ديسمبر',
    },
};
